export enum RLSTypesEnum{
    FullEmail = 1,
    GroupName = 2,
    EmailDomain = 3,
    ssasEIdUsername = 4
}